import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import IRequest from "../../types/services/IRequest";
import { ExportType } from "../../Admin/components/exportModal";
import IColumnName from "../../types/IColumnName";
import { IPost } from "../../types/services/IPost";
import IDonation from "../../types/services/IDonation";

interface State {
  showLoginModal: boolean;
  showExportModal: boolean;
  showThankYouModal: boolean;
  showEditGiveUrlModal: boolean;
  showMediaModal: boolean;
  showAddDonorModal: boolean;
  showSegmentManagerModal: boolean;
  updateComponentFunction?: () => void;

  showColumnsModal: boolean;
  changeColumnFunction?: (index) => void;
  columnNames?: Array<IColumnName>;

  donations?: Array<IDonation>;
  exportType?: ExportType;
  exportIdsArray?: [string];
  exportTotalIds?: string;
  exportFromDate?: number;
  exportToDate?: number;
  ignoreSelected?: boolean;
  donorId?: string;
  exportCharity?: string;
  donorIds?: Array<string>;
  isFlag?: boolean;
  segmentId?: string;
  filterBy?: string;
  summaryExport?: boolean;
  showUpdateProfileModal: boolean;
  showChangePasswordModal: boolean;
  showCreateRequestModal: boolean;
  showRequestDetailModal: boolean;
  request?: IRequest;

  mediaBlobs?: Array<Blob | string>;

  donorFlagId?: string;
  donorFlagDonors?: Array<string>;

  showPostNotificationModal: boolean;
  post?: IPost;

  onlyImage: boolean;

  hideCustomThumbnail: boolean;
  existingPreviewUrl?: string;
  existingPreviewIsCustom: boolean;
  mediaModalPostTitle?: string;

  showCustomThumbnailModal: boolean;
  thumbnailBlob?: Blob;
  customThumbnailUpload: boolean;

}

const initialState: State = {
  showLoginModal: false,
  showExportModal: false,
  showThankYouModal: false,
  showEditGiveUrlModal: false,
  showUpdateProfileModal: false,
  showColumnsModal: false,
  showChangePasswordModal: false,
  showCreateRequestModal: false,
  showRequestDetailModal: false,
  showMediaModal: false,
  showAddDonorModal: false,
  showSegmentManagerModal: false,
  showPostNotificationModal: false,
  onlyImage: false,
  hideCustomThumbnail: false,
  existingPreviewIsCustom: false,
  showCustomThumbnailModal: false,
  customThumbnailUpload: false,
};

export default function modalReducer(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case actionTypes.LOGIN_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        showLoginModal: !state.showLoginModal,
      };
    }

    case actionTypes.EXPORT_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showExportModal: !state.showExportModal,
      };
    }

    case actionTypes.THANK_YOU_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showThankYouModal: !state.showThankYouModal,
      };
    }

    case actionTypes.EDIT_GIVE_URL_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showEditGiveUrlModal: !state.showEditGiveUrlModal,
      };
    }

    case actionTypes.COLUMN_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showColumnsModal: !state.showColumnsModal,
      };
    }
    case actionTypes.COLUMN_MODAL_CHANGE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showColumnsModal: state.showColumnsModal,
      };
    }
    case actionTypes.USER_PROFILE_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        showUpdateProfileModal: !state.showUpdateProfileModal,
      };
    }
    case actionTypes.CHANGE_PASSWORD_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        showChangePasswordModal: !state.showChangePasswordModal,
      };
    }
    case actionTypes.CREATE_REQUEST_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        showCreateRequestModal: !state.showCreateRequestModal,
      };
    }
    case actionTypes.REQUEST_DETAIL_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showRequestDetailModal: !state.showRequestDetailModal,
      };
    }
    case actionTypes.MEDIA_MODAL_TOGGLE: {
      const customThumbnailUpload = Boolean(action.payload.customThumbnailUpload);
      return {
        ...state,
        ...initialState,
        showMediaModal: !state.showMediaModal,
        mediaBlobs: action.payload.mediaBlobs,
        onlyImage: action.payload.onlyImage,
        hideCustomThumbnail: Boolean(action.payload.hideCustomThumbnail),
        existingPreviewUrl: action.payload.existingPreviewUrl,
        existingPreviewIsCustom: Boolean(action.payload.existingPreviewIsCustom),
        mediaModalPostTitle: action.payload.mediaModalPostTitle,
        customThumbnailUpload,
        thumbnailBlob: customThumbnailUpload ? state.thumbnailBlob : undefined,
      };
    }
    case actionTypes.MEDIA_MODAL_BLOBS_CLEAR: {
      if (state.showMediaModal) {
        return state;
      }
      return {
        ...state,
        mediaBlobs: undefined,
        thumbnailBlob: undefined,
      };
    }
    case actionTypes.CUSTOM_THUMBNAIL_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        showMediaModal: state.showMediaModal,
        hideCustomThumbnail: state.hideCustomThumbnail,
        existingPreviewUrl: state.existingPreviewUrl,
        existingPreviewIsCustom: state.existingPreviewIsCustom,
        mediaModalPostTitle: state.mediaModalPostTitle,
        showCustomThumbnailModal: !state.showCustomThumbnailModal,
        thumbnailBlob: action.payload.thumbnailBlob,
      };
    }
    case actionTypes.RESET_CUSTOM_THUMBNAIL_MODAL: {
      return {
        ...state,
        ...initialState,
        showMediaModal: state.showMediaModal,
        hideCustomThumbnail: state.hideCustomThumbnail,
        existingPreviewUrl: state.existingPreviewUrl,
        existingPreviewIsCustom: state.existingPreviewIsCustom,
        mediaModalPostTitle: state.mediaModalPostTitle,
        showCustomThumbnailModal: action.payload.showModal,
        thumbnailBlob: action.payload.thumbnailBlob,
      };
    }
    case actionTypes.DONOR_FLAG_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showAddDonorModal: !state.showAddDonorModal,
      };
    }
    case actionTypes.SEGMENT_MANAGER_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showSegmentManagerModal: !state.showSegmentManagerModal,
      };
    }
    case actionTypes.POST_NOTIFICATION_MODAL_TOGGLE: {
      return {
        ...state,
        ...initialState,
        ...action.payload,
        showPostNotificationModal: !state.showPostNotificationModal,
      };
    }
    default: {
      return state;
    }
  }
}

export { initialState };
